import {createContext} from 'react'

export const AnalyticsContext = createContext<{platform: string}>({platform: 'Web'})
